import React, { Component } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
} from '@coreui/react';
import { APIS } from '../../config';

class TotalSupply extends Component {
    state = {
        totalSupply: null, // Set to null initially
        loading: true, // Track loading state
    };

    async componentDidMount() {
        try {
            const res = await fetch(APIS + 'metamui/total_issuance');
            const data = await res.json();
            this.setState({ totalSupply: data, loading: false });
        } catch (error) {
            console.error(error);
            this.setState({ loading: false }); // Ensure loading is set to false on error
        }
    }

    formatNumber(num) {
        const parsedNum = typeof num === 'number' ? num : parseFloat(num);

        if (isNaN(parsedNum)) return num;

        return parsedNum.toLocaleString(undefined, {
            minimumFractionDigits: 6,
            maximumFractionDigits: 6,
        });
    }

    render() {
        const { totalSupply, loading } = this.state;

        return (
            <CCard>
                <CCardHeader>
                    <strong>Total Issuance</strong>
                </CCardHeader>
                <CCardBody>
                    {loading ? (
                        <h3>Loading...</h3> // Display a placeholder while loading
                    ) : totalSupply !== null ? (
                        <h3>{this.formatNumber(totalSupply)} MetaMUI</h3> // Show formatted data
                    ) : (
                        <h3>No data available</h3> // Handle case if no data is returned
                    )}
                </CCardBody>
            </CCard>
        );
    }
}

export default TotalSupply;
